const Footer = () => {
    return ( 
        <footer>
            
			<footer className="attribution">
				Challenge by<div>&nbsp;</div>
				<a
					href="https://www.frontendmentor.io?ref=challenge"
					target="_blank"
					rel="noopener noreferrer"
				>
					Frontend Mentor
				</a>
				. Coded by<div>&nbsp;</div>
				<a
					href="https://github.com/adsyahir"
					target="_blank"
					rel="noopener noreferrer"
				>
					Adam Syahir
				</a>
				.
			</footer>
        </footer>
     );
}
 
export default Footer;